module.exports = "<div style=\"margin-top: 20px\" *ngIf=\"form\" >\n  <div>Detalhes do form</div>\n  <pre>Form válido: {{ form.valid }}</pre>\n  <!--pre>Form submetido: {{ form.submitted }}</pre -->\n  <pre>Valores: <br>{{ form.value | json }}</pre>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// D:/desv/producao/hc/angular/adminHC/src/app/shared/form-debug/form-debug.component.html
// module id = ../../../../../src/app/shared/form-debug/form-debug.component.html
// module chunks = main